import { render, staticRenderFns } from "./FamilyMembers.vue?vue&type=template&id=25567d8b&scoped=true&"
import script from "./FamilyMembers.vue?vue&type=script&lang=js&"
export * from "./FamilyMembers.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMembers.vue?vue&type=style&index=0&id=25567d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25567d8b",
  null
  
)

export default component.exports